import { Injectable } from "@angular/core";
import { PostModel } from "../interfaces/article.interface";
import { ActivatedRoute, Router } from "@angular/router";
import { JobModel } from "../interfaces/job-status.interface";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { OrderPagingModel } from "../interfaces/order.interface";

@Injectable({
    providedIn: "root",
})
export class SharedService {
    public sidebarLoading: boolean = false;
    public collapseSidebar: boolean = false;
    public search: boolean = false;
    public selectedProductId: number = 0;
    public selectedUsername: string = "";
    public selectedMissionCode: string = "";
    public selectedPostSlug: string | undefined;
    public selectedPostCatSlug: string | undefined;
    public showBackButton: boolean = false;
    public selectedPost: PostModel | undefined;
    public selectedJobStatus: JobModel | undefined;

    private notificationPoll =  new BehaviorSubject(undefined);
    public newNotification$ = this.notificationPoll.asObservable();
    publishNewNotification() {
        this.notificationPoll.next(undefined);
    }

    private notificationChangeBehavior =  new BehaviorSubject(undefined);
    public notificationChange$ = this.notificationChangeBehavior.asObservable();
    notificationChange() {
        this.notificationChangeBehavior.next(undefined);
    }

    private qPage: number = -1;
    private qPageSize: number = -1;
    constructor(private route: ActivatedRoute,
        private router: Router) {
    }
    getPager(totalItems: number, currentPage: number, pageSize: number, paginateRange: number) {
        this.qPage = this.getCurrentPage();
        this.qPageSize = this.getPageSize();

        if (this.qPageSize > 0) {
            pageSize = this.qPageSize;
        }

        // calculate total pages
        let totalPages = Number(Math.ceil(Number(totalItems) / Number(pageSize)));

        // Paginate Range
        paginateRange = paginateRange ?? 0;

        // ensure current page isn't out of range
        if (this.qPage > 0 && this.qPage <= Number(totalPages)) {
            currentPage = this.qPage;
        } else if (Number(currentPage) < 1) {
            currentPage = 1;
        } else if (Number(currentPage) > Number(totalPages)) {
            currentPage = Number(totalPages);
        }

        let startPage: number, endPage: number;
        if (Number(totalPages) <= Number(paginateRange)) {
            // Less than or equal to the paginateRange
            startPage = 1;
            endPage = Number(totalPages);
        } else if (Number(currentPage) <= Number(Math.floor(Number(paginateRange) / 2))) {
            // Near the beginning
            startPage = 1;
            endPage = Number(paginateRange);
        } else if (Number(currentPage) >= Number(totalPages) - Number(Math.floor(Number(paginateRange) / 2))) {
            // Near the end
            startPage = Number(totalPages) - Number(paginateRange) + 1;
            endPage = Number(totalPages);
        } else {
            // In the middle
            startPage = Number(currentPage) - Number(Math.floor(Number(paginateRange) / 2));
            endPage = Number(currentPage) + Number(Math.floor(Number(paginateRange) / 2));
        }

        // calculate start and end item indexes
        let startIndex = (Number(currentPage) - 1) * Number(pageSize);
        let endIndex = Math.min(Number(startIndex) + Number(pageSize) - 1, Number(totalItems) - 1);


        // create an array of pages to ng-repeat in the pager control
        let pages = Array.from(Array((Number(endPage) + 1) - Number(startPage)).keys()).map(i => Number(startPage) + Number(i));
        if (currentPage !== this.qPage && currentPage > 0 && this.qPage > 0) {
            this.router.navigate([], { relativeTo: this.route, queryParams: { page: currentPage }, queryParamsHandling: 'merge', replaceUrl: true });
        }

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    getCurrentPage(): number {
        if (this.route.snapshot.queryParams['page'] && typeof parseInt(this.route.snapshot.queryParams['page']) === 'number') {
            return parseInt(this.route.snapshot.queryParams['page']);
        }
        return -1;
    }

    getPageSize(): number {
        if (this.route.snapshot.queryParams['pageSize'] && typeof parseInt(this.route.snapshot.queryParams['pageSize']) === 'number') {
            return parseInt(this.route.snapshot.queryParams['pageSize']);
        }
        return -1;
    }

    buildBody<T extends object>(body: any) {
        let instance = new body();
        for (let key in instance) {
            if (this.route.snapshot.queryParams[key]) {
                if (instance[key as keyof T] instanceof Array) {
                    const propertyType = typeof instance[key][0];
                    switch (propertyType) {
                        case 'number':
                            instance[key] = this.route.snapshot.queryParams[key].split(',').map(Number);
                            break;
                        case 'string':
                            instance[key] = this.route.snapshot.queryParams[key].split(',');
                            break;
                        default:
                            instance[key] = this.route.snapshot.queryParams[key].split(',');
                            break;
                    }
                }
                else {
                    const propertyType = typeof instance[key]
                    switch (propertyType) {
                        case 'number':
                            instance[key] = Number(this.route.snapshot.queryParams[key]);
                            break;
                        case 'string':
                            instance[key] = this.route.snapshot.queryParams[key];
                            break;
                        case 'boolean':
                            instance[key] = this.route.snapshot.queryParams[key] === 'true';
                            break;
                        default:
                            instance[key] = this.route.snapshot.queryParams[key];
                            break;
                    }
                }
            }
            else {
                delete instance[key];
            }
        }
        return instance;
    }

    buildQueryParams(value: any) {
        setTimeout(() => {
            this.router.navigate([], { relativeTo: this.route, queryParams: value, queryParamsHandling: 'merge', replaceUrl: true });
        }, 10);
    }
}
